import React from "react";
import { RenderContainerProps } from "./model";

export const RenderContainer: React.FC<RenderContainerProps> = ({
  customFieldName,
  classWrapper,
  orderNumber,
  children,
}) => {
  return (
    <div className={`FormBox FormSideBySide`}>
      <div className="FormLabel">
        <label>{`${customFieldName}`}</label>
        {/* ${ orderNumber || orderNumber === 0 ? `${orderNumber + 1}.` : "" // No longer want to display orderNumber} */}
      </div>
      <div className="FormField">{children}</div>
    </div>
  );
};
